import styled from 'styled-components'

export const Container = styled.div<{ width: string}>`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.width};
    height: 16rem;
    gap: .4rem;
`

export const Title = styled.div`
    display: flex;
    flex-direction: column;
`

export const Item = styled.div`
    display: flex;
    align-items: flex-start;
    gap: .4rem;
`
export const MoreInformation = styled.div`
    display: flex;
    align-items: flex-start;
    margin-top: .6rem;
    gap: .4rem;
`
export const Information = styled.div`
    display: flex;
    flex-direction: column;
    gap: .4rem;
`
